import gql from 'graphql-tag';

export default gql`
	mutation ActivateUser($id: ID, $active: Boolean) {
		activateUser(id: $id, active: $active) {
			id
		}
	}
`;



// WEBPACK FOOTER //
// ./src/mutations/activateUser.js